import { render, staticRenderFns } from "./CourseForm.vue?vue&type=template&id=4eabd9bc&"
import script from "./CourseForm.vue?vue&type=script&lang=ts&"
export * from "./CourseForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports